import { render } from "./Accepted.vue?vue&type=template&id=f85a3976"
import script from "./Accepted.vue?vue&type=script&lang=js"
export * from "./Accepted.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__